export default __webpack_public_path__ + "img/cMsacaQG.9d08c4df.svg";